import type { SVGProps } from 'react';
const SvgSelectDropdown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="currentColor"
      d="m8.002 10.339 3.621-3.95a.81.81 0 0 1 .6-.27c.224 0 .44.096.599.27a.97.97 0 0 1 .248.652 1 1 0 0 1-.064.353.9.9 0 0 1-.184.299l-4.221 4.593a.85.85 0 0 1-.275.202.79.79 0 0 1-.649 0 .85.85 0 0 1-.275-.202l-4.22-4.593a.9.9 0 0 1-.186-.299 1 1 0 0 1 0-.707.9.9 0 0 1 .185-.299.8.8 0 0 1 .275-.2.79.79 0 0 1 .65 0 .8.8 0 0 1 .274.2z"
    />
  </svg>
);
export default SvgSelectDropdown;
